import { apiClient } from "@/lib/api-client";

export interface ValidateOtpRequest {
  email: string;
  otp: string;
  captchaToken?: string;
}

export interface ResendOtpRequest {
  email: string;
  captchaToken?: string;
}

export interface ValidateOtpResponse {
  user: {
    id?: string;
    externalId?: string;
    status: number;
    email: string;
    firstName: string;
    lastName: string;
    createdAt?: string;
    lastLoginAt?: string;
    currentOrganizationId?: string | null;
    needsLegalConsent?: boolean;
    organizationRole?: string | null;
  };
  roles: string[];
  permissions: string[];
  expiresAt: string;
}

export interface OtpResponse {
  message: string;
}

export async function validateOtpAsync(
  request: ValidateOtpRequest,
): Promise<ValidateOtpResponse> {
  const response = await apiClient.put<ValidateOtpResponse>(
    "/auth/validate-otp",
    request,
  );
  return response.data;
}

export async function resendOtpAsync(
  request: ResendOtpRequest,
): Promise<OtpResponse> {
  const response = await apiClient.post<OtpResponse>(
    "/auth/resend-otp",
    request,
  );
  return response.data;
}
